import {AbstractControl, NG_VALIDATORS, ValidationErrors, Validator} from "@angular/forms";
import {Directive} from "@angular/core";
import {BusinessObjectsDictionaryService} from "../services/dictionaries/business-objects-dictionary.service";
import {ICodeName} from "@common/interfaces";

// Валидатор для автокомплита "Виды деятельности"
@Directive({
  selector: "[existingLegalPersonActivityCode]",
  providers: [
    {provide: NG_VALIDATORS, useExisting: LegalPersonActivityValidator, multi: true},
  ],
})
export class LegalPersonActivityValidator implements Validator {
  constructor(private businessObjectsDictionaryService: BusinessObjectsDictionaryService) {
  }

  public validate(control: AbstractControl): ValidationErrors | null {
    if (control.value == null) {
      return;
    }

    const hasLegalPersonActivityCode = this.businessObjectsDictionaryService
      .legalPersonActivities
      .some((dept: ICodeName) => dept.code === control.value);

    if (hasLegalPersonActivityCode) {
      return null;
    }

    return {
      "codeNotExists": {
        "translateKey": "incorrect-legal-person-activity",
        "value": control.value,
      }
    };
  }
}
